export default __webpack_public_path__ + "static/send-video-dark-d5513678afcc806df59351d2a0acde79.png";